import React, { useContext, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CartContext } from '../context/CartContext';

export default function ProductCard({ product, index }) {
  const { addToCart } = useContext(CartContext);
  const navigate = useNavigate();
  const { businessName, salePointName } = useParams();
  const [imageSrc, setImageSrc] = useState(
    product.imageUrl || '/assets/SalePoint1631330663733.jpg'
  );

  const handleCardClick = () => {
    navigate(`/${businessName}/${salePointName}/product/${product.id}`);
  };

  // Only meaningful for non-variant products — variant products always show
  // "اختر التشكيلة" regardless of stock, since availability depends on which
  // combination the customer picks on the detail page.
  const outOfStock = !product.hasVariants && product.stockQuantity === 0;

  const handleActionClick = (e) => {
    e.stopPropagation();
    if (product.hasVariants) {
      // Can't add a variant product straight from the card — no combination
      // chosen yet. Send them to the detail page where the picker lives.
      handleCardClick();
    } else if (!outOfStock) {
      addToCart(product);
    }
  };

  const imageUrl = imageSrc;

  let buttonLabel = 'أضف إلي العربة';
  if (product.hasVariants) buttonLabel = 'اختر التشكيلة';
  else if (outOfStock) buttonLabel = 'نفذت الكمية';

  return (
    <div
      className="product-card fade-in"
      style={{ animationDelay: `${index * 100}ms` }}
      onClick={handleCardClick}
    >
      <img
        src={imageUrl}
        alt={product.name}
        className="product-image"
        loading="lazy"
        onError={(e) => {
          e.target.onerror = null;
          setImageSrc('/assets/SalePoint1631330663733.jpg');
        }}
      />
      <div className="product-info">
        <h3>{product.name}</h3>
        <p>IQD {product.price.toFixed(2)}</p>

        {!product.hasVariants && !product.sellIfNotProvidedInStore && typeof product.stockQuantity === 'number' && (
          <p className={outOfStock ? 'stock-text stock-out' : 'stock-text stock-available'}>
            {outOfStock ? 'نفذت الكمية' : `الكمية المتوفرة: ${product.stockQuantity}`}
          </p>
        )}

        <button
          onClick={handleActionClick}
          className="btn-add"
          disabled={outOfStock}
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  );
}